// extracted by mini-css-extract-plugin
export default {"navItem":"styles-module--nav-item--1yJMi","navLink":"styles-module--nav-link--1uTlF","active":"styles-module--active--17Tgx"};